import * as React from "react";
import { Control, Errors } from "react-redux-form";
import * as DTOS from "../../../../FeralScan.dtos";
import * as DashboardActionCreators from "../../../../actions/dashboard.actions";
import * as SurveyActionCreators from "../../../../actions/survey.actions";
import FileUpload from "./FileUpload";
import { showErrors } from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";

export type FileUploadControlProps = {
    model: string,
    questionIndex: number,
    survey: DTOS.Survey,
    type: "image" | "video" | "both";
    className?: string;
    uploadingFile: boolean;
};

export type FileUploadControlActions = {
    error: typeof DashboardActionCreators.errorRequest,
    onDrop?: (acceptedFiles: File[], rejectedFiles: File[]) => void,
    uploadFiles: typeof SurveyActionCreators.uploadFilesRequest
};

export type FileUploadControlPropsAndActions = FileUploadControlProps & FileUploadControlActions

const maxFilesAllowed: number = 2

class FileUploadControl extends React.PureComponent<FileUploadControlPropsAndActions, any> {
    constructor(props: FileUploadControlPropsAndActions) {
        super(props);

        this.onDrop = this.onDrop.bind(this);
        this.maximumFilesUploaded = this.maximumFilesUploaded.bind(this);
    }

    onDrop(acceptedFiles: File[], rejectedFiles: File[]) {
        if (this.props.onDrop) {
            this.props.onDrop(acceptedFiles, rejectedFiles);
        }

        if (acceptedFiles && acceptedFiles.length > 0) {

            if(this.maximumFilesUploaded()){
                acceptedFiles.map(file => this.props.error(`Maximum of ${maxFilesAllowed} file${maxFilesAllowed > 1 ? 's' : ''}. ${file.name} could not be uploaded.`));
            } else {
                this.props.uploadFiles(this.props.questionIndex, acceptedFiles);
            }

        }
        if (rejectedFiles && rejectedFiles.length > 0) {
            rejectedFiles.map(file => this.props.error(file.size > 4126939 ? `${file.name} exceeds the maximum file size for uploads.` : `The file type of ${file.name} is not supported.`));
        }
    }

    maximumFilesUploaded(): boolean {
        return this.props.survey.questions[this.props.questionIndex].value && this.props.survey.questions[this.props.questionIndex].value.split(",").length >= maxFilesAllowed;
    }

    render() {
        return (
            <div className={this.props.className}>
                {
                    this.props.uploadingFile ? <p className="ml-2">Uploading file...</p> : undefined
                }
                <Control
                    component={FileUpload}
                    controlProps={{
                        type: this.props.type,
                        uniqueId: this.props.questionIndex,
                        uploadedFiles: this.props.survey.questions[this.props.questionIndex].value,
                        onDrop: this.onDrop,
                        uploadingFile: this.props.uploadingFile,
                        disableDropZone: this.props.survey.questions[this.props.questionIndex].value && this.props.survey.questions[this.props.questionIndex].value.split(",").length >= maxFilesAllowed
                    }}
                    model={this.props.model}
                />
                <Errors
                    className="invalid-feedback d-block"
                    model={this.props.model}
                    messages={{/* TODO? */}}
                    show={showErrors}
                    component={ValidationMessage}
                />
            </div>
        );
    }
}

export default FileUploadControl;
